import { api } from './api';

export interface McpToken {
  id: string;
  name: string;
  created_at: string;
  last_used_at: string | null;
}

export const mcpApi = {
  list: (wsId: string): Promise<McpToken[]> =>
    api.get(`/api/workspaces/${wsId}/mcp-tokens`).then((r) => r.data),
  create: (wsId: string, name: string): Promise<{ token: string; id: string }> =>
    api.post(`/api/workspaces/${wsId}/mcp-tokens`, { name }).then((r) => r.data),
  revoke: (wsId: string, id: string): Promise<void> => {
    return api.delete(`/api/workspaces/${wsId}/mcp-tokens/${id}`).then(() => undefined);
  },
};

/** The MCP endpoint clients connect to (derived from the configured API base).
 *  Routes live under the global `/api` prefix, so the public endpoint is /api/mcp. */
export function mcpEndpoint(): string {
  const base = (import.meta.env.VITE_API_URL as string | undefined) || window.location.origin;
  return `${base.replace(/\/$/, '')}/api/mcp`;
}
